module.exports = __webpack_public_path__ + "static/antartica-nocturna-02eb90cd3eb896536dcde1b59952c572.jpg";